import React, { useEffect, useState } from 'react';

export const IntroAnimation: React.FC<{ onComplete: () => void }> = ({ onComplete }) => {
    const [stage, setStage] = useState(0);

    useEffect(() => {
        // Sequence of animations
        const t1 = setTimeout(() => setStage(1), 500); // Fade in logo
        const t2 = setTimeout(() => setStage(2), 2000); // Expand/Move logo
        const t3 = setTimeout(() => setStage(3), 3500); // Fade out
        const t4 = setTimeout(() => onComplete(), 4000); // Complete

        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
            clearTimeout(t3);
            clearTimeout(t4);
        };
    }, [onComplete]);

    if (stage === 3) return null;

    return (
        <div className={`fixed inset-0 z-50 flex items-center justify-center bg-slate-900 transition-opacity duration-700 ${stage === 3 ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}>
            <div className="relative flex flex-col items-center">
                {/* Animated Circle Background */}
                <div className={`absolute inset-0 bg-blue-500/20 blur-3xl rounded-full scale-0 transition-transform duration-1000 ${stage >= 1 ? 'scale-150' : ''}`} />

                {/* Logo / Text */}
                <div className={`relative z-10 transform transition-all duration-1000 ${stage === 0 ? 'translate-y-10 opacity-0' : 'translate-y-0 opacity-100'} ${stage === 2 ? 'scale-110' : ''}`}>
                    <h1 className="text-6xl font-bold text-white tracking-tighter">
                        <span className="text-blue-500">Q</span>ssun
                        <span className="font-light text-slate-300">Reports</span>
                    </h1>
                    <p className={`mt-4 text-center text-slate-400 tracking-widest uppercase text-sm transition-opacity duration-700 delay-500 ${stage >= 1 ? 'opacity-100' : 'opacity-0'}`}>
                        System Loading...
                    </p>
                </div>
            </div>
        </div>
    );
};
